module.exports = __webpack_public_path__ + "static/media/success.aff88dbf.png";